import propOr from 'ramda/src/propOr';
import { FETCH_SUBSCRIPTION, UPDATE_SUBSCRIPTION } from '../constants';

const subscription = (state = null, action) => {
  switch (action.type) {
    case FETCH_SUBSCRIPTION:
    case UPDATE_SUBSCRIPTION:
      return action.payload;
    default:
      return state;
  }
};

export default subscription;

export const getSubscription = state => state.admin.subscriptions.subscription;
export const getSubscriptionId = state => propOr(null, 'id', getSubscription(state));

